"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FeaturesStripe } from "@/components/landing/features-stripe";

export function BusinessTypeFeatures() {
  return (
    <div>
      <section id="how-it-works" className="relative overflow-hidden">
        <div className="relative px-4 pt-20 md:pt-30 z-10">
          <div className="max-w-6xl mx-auto ">
            <h3 className="text-[2rem] text-neutral-900 text-center md:text-[4.5rem] font-display tracking-[-0.01em] md:tracking-[-0.03em] leading-[1.25] md:leading-[1.14] font-medium text-pretty">
              See why modern <br />
              businesses made the switch
            </h3>
            <div className="flex flex-col md:flex-row gap-12">
              <div className="bg-[#eef0f0] w-full my-28 rounded-3xl py-6 px-7 flex gap-6">
                <div className="flex flex-col justify-between">
                  <div>
                    <span>Payments & Point of sale</span>
                    <h2 className="text-4xl md:text-5xl text-neutral-900 mt-5">
                      Grow with every transaction
                    </h2>
                  </div>
                  <div className="mt-14 md:mt-24">
                    <Accordion
                      type="single"
                      collapsible
                      defaultValue="1"
                      className="w-full"
                    >
                      <AccordionItem value="1">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Protect every appointment
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4 ">
                          Take a deposit or full payment when clients book online,
                          and charge a cancellation fee when clients cancel late.
                        </AccordionContent>
                      </AccordionItem>
                      <AccordionItem value="2">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Sell more than the service
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4">
                          Add retail products, packages, and gift cards to the
                          same sale, with preset tip amounts at checkout.
                        </AccordionContent>
                      </AccordionItem>
                      <AccordionItem value="3">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Boost rebooking
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4">
                          Rebook clients in one click from their appointment, and
                          send automated reminders inviting them back after each
                          visit.
                        </AccordionContent>
                      </AccordionItem>
                      <AccordionItem value="4">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Accept any payment type
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4">
                          Take cards through Stripe, Square Terminal, or Clover
                          devices, plus cash, gift cards, and invoices clients
                          pay online.
                        </AccordionContent>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </div>
              </div>
              <div className="bg-[#eef0f0] w-full my-28 rounded-3xl py-6 px-7 flex gap-6">
                <div className="flex flex-col justify-between">
                  <div>
                    <span>Client relationships</span>
                    <h2 className="text-4xl md:text-5xl text-neutral-900 mt-5">
                      Turn clients into regulars
                    </h2>
                  </div>
                  <div className="mt-14 md:mt-24">
                    <Accordion
                      type="single"
                      collapsible
                      defaultValue="5"
                      className="w-full"
                    >
                      <AccordionItem value="5">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Provide fast, login free client booking
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4">
                          Book more clients fast with login free client booking
                          on your free Zobliss Booking Website.
                        </AccordionContent>
                      </AccordionItem>
                      <AccordionItem value="6">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Create email & text campaigns in seconds
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4">
                          Keep bookings and retention high by promoting your
                          latest services and offers with marketing assistance.
                        </AccordionContent>
                      </AccordionItem>
                      <AccordionItem value="7">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Keep client details organized and up to date
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4">
                          Easily track key client details like past service
                          notes, preferences, before & after images, birthdays,
                          and more with Client Profiles.
                        </AccordionContent>
                      </AccordionItem>
                      <AccordionItem value="8">
                        <AccordionTrigger
                          className="text-xl border-b rounded-none"
                          arrowClassName="size-5 text-neutral-900"
                        >
                          Get more Google reviews
                        </AccordionTrigger>
                        <AccordionContent className="text-neutral-800 text-base mt-4">
                          Build your reputation and reach more clients by
                          prompting happy clients to leave a review on your
                          Google Business Profile after their visit.
                        </AccordionContent>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
